(function () {

    'use strict';

    angular.module('iplusjs.utils.scrollIntoView', [
        'lodash',
        'modernizr',
        'iplusjs.utils.html'
    ])
    .directive('iplusjsScrollIntoView', scrollIntoView);

    scrollIntoView.$inject = [
        '$timeout',
        'lodash',
        'HtmlUtilsService'
    ];
    function scrollIntoView($timeout, _, HtmlUtilsService) {
        return {
            restrict: 'A',
            link: function ($scope, $element, $attrs) {
                $scope.$watch($attrs.iplusjsScrollIntoView, function (value) {
                    $timeout(function () {
                        var el,
                            forceScroll = $attrs.isivForceScroll === 'true' ? true : false;

                        if (value || _.isElement(value)) {
                            el = _.isElement(value) ? value : $element[0];

                            HtmlUtilsService.scrollIntoViewIfNeeded(el, forceScroll);
                        }
                    });
                });
            }
        };
    }

})();
